import React, { useState } from "react";

import { createPortal } from "react-dom";
import styled from "styled-components";

import { useModal } from "../../../ContextApi/modal/modalContext";

const CallPopup = () => {
  const { closeModal } = useModal();
  const [pass, setPass] = useState(true);

  const handlePass = () => {
    setPass(!pass);
  };

  return (
    <>
      <div
        className={` fixed inset-0 flex items-center justify-center cstmModal z-[99999]`}
      >
        <div
          onClick={closeModal}
          className="absolute inset-0 bg-[#0009] shadow-sm backdrop-blur-[10px] "
        ></div>
        <div
          className={` modalDialog relative p-2 mx-auto rounded-[23px] z-10 bg-[#fff] max-w-[550px] border border-[#1A1A1A]  w-full`}
        >
          <div className="modalBody md:px-5 px-3 py-5">
            <button
              onClick={closeModal}
              className="flex items-center justify-center rounded-full absolute top-4 right-4"
            >
              {closeIcn}
            </button>
            <div className="">
              <h5 className="m-0 font-semibold text-[18px]">
                Start your call with
              </h5>
              <div className="frmWrpper mt-4">
                <div className="pb-4 text-center">
                  <img
                    src={"/assets/media/models/m1.png"}
                    className="max-w-full h-[150px] w-[150px] mx-auto rounded-full object-cover"
                    alt=""
                    height={1000}
                    width={1000}
                  />
                  <p className="m-0 pt-4 text-[22px]">Valentina Cruz</p>
                </div>
                <div className="py-2">
                  <div className="flex items-center gap-2">
                    <input type="checkbox" className="form-check" />
                    <p className="m-0 text-white/70">
                      Don't show this message again
                    </p>
                  </div>
                </div>
                <div className="py-2">
                  <button
                    className="flex items-center justify-center gap-2 bg-[#E443A6] rounded-[10px] h-[50px] text-[14px] w-full text-white font-medium opacity-70"
                    style={{ pointerEvents: "none", cursor: "not-allowed" }}
                  >
                    {callIcn} Call
                  </button>
                </div>
                <div className="py-2">3 Tokens/min</div>
                <div className="py-2">
                  Tips: <br />
                  Please speak clearly and loudly.{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CallPopup;

const callIcn = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7483 12.1297C13.3161 13.4429 11.6231 14.0978 10.4135 13.9886C8.76147 13.8393 6.96388 12.9631 5.59934 11.998C3.59361 10.5793 1.71481 8.38488 0.620009 6.05621C-0.153724 4.41074 -0.327322 2.38765 0.823478 0.887786C1.24908 0.333386 1.70921 0.0372935 2.40081 0.00276018C3.36028 -0.0439065 3.49468 0.504988 3.82414 1.35992C4.06961 1.99925 4.39721 2.65142 4.58014 3.31409C4.92268 4.55076 3.72521 4.60244 3.57401 5.61324C3.47974 6.25071 4.25254 7.10558 4.60161 7.56012C5.28574 8.45052 6.10801 9.21849 7.03574 9.80276C7.56681 10.1378 8.42454 10.7416 9.03307 10.4084C9.97014 9.89509 9.88147 8.31503 11.1919 8.84983C11.8704 9.1261 12.5275 9.52479 13.1752 9.87385C14.1767 10.4124 14.13 10.9705 13.7483 12.1297C14.0339 11.2636 13.4627 12.9958 13.7483 12.1297Z"
      fill="white"
    />
  </svg>
);

const closeIcn = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2_15788)">
      <path
        d="M12.4396 1.43799C12.5774 1.29234 12.7429 1.17578 12.9265 1.0952C13.1101 1.01463 13.308 0.971683 13.5085 0.968895C13.709 0.966107 13.908 1.00354 14.0937 1.07897C14.2795 1.15441 14.4482 1.26632 14.59 1.40809C14.7318 1.54986 14.8437 1.71861 14.9191 1.90437C14.9946 2.09013 15.032 2.28913 15.0292 2.48961C15.0264 2.69008 14.9835 2.88796 14.9029 3.07155C14.8223 3.25515 14.7058 3.42072 14.5601 3.55849L10.1651 7.95349C10.1593 7.9593 10.1547 7.9662 10.1515 7.97379C10.1484 7.98138 10.1467 7.98952 10.1467 7.99774C10.1467 8.00597 10.1484 8.01411 10.1515 8.0217C10.1547 8.02929 10.1593 8.03619 10.1651 8.04199L14.5601 12.437C14.7013 12.5758 14.8135 12.7413 14.8905 12.9237C14.9674 13.1062 15.0074 13.3021 15.0082 13.5001C15.0091 13.6981 14.9707 13.8943 14.8953 14.0774C14.8199 14.2605 14.709 14.4269 14.569 14.5669C14.429 14.7069 14.2627 14.8179 14.0796 14.8933C13.8965 14.9687 13.7003 15.0072 13.5023 15.0064C13.3043 15.0056 13.1084 14.9656 12.9259 14.8887C12.7434 14.8119 12.578 14.6996 12.4391 14.5585L8.0441 10.1635C8.03829 10.1577 8.03139 10.1531 8.0238 10.1499C8.01621 10.1468 8.00807 10.1451 7.99985 10.1451C7.99163 10.1451 7.98349 10.1468 7.97589 10.1499C7.9683 10.1531 7.9614 10.1577 7.9556 10.1635L3.5606 14.5585C3.42174 14.6997 3.25631 14.8119 3.07385 14.8889C2.89139 14.9658 2.6955 15.0058 2.49749 15.0066C2.29949 15.0074 2.10327 14.9691 1.92017 14.8937C1.73707 14.8183 1.57071 14.7074 1.43068 14.5674C1.29064 14.4274 1.17972 14.2611 1.10429 14.078C1.02887 13.8949 0.99044 13.6987 0.991223 13.5007C0.992006 13.3027 1.03198 13.1068 1.10885 12.9243C1.18572 12.7418 1.29796 12.5764 1.4391 12.4375L5.8341 8.04249C5.83992 8.03669 5.84453 8.02979 5.84769 8.0222C5.85084 8.01461 5.85246 8.00647 5.85246 7.99824C5.85246 7.99002 5.85084 7.98188 5.84769 7.97429C5.84453 7.9667 5.83992 7.9598 5.8341 7.95399L1.4391 3.55899C1.16154 3.27695 1.00668 2.89666 1.00825 2.50095C1.00981 2.10524 1.16767 1.72619 1.44745 1.44635C1.72722 1.1665 2.10625 1.00855 2.50195 1.00689C2.89766 1.00524 3.27799 1.16001 3.5601 1.43749L7.9551 5.83249C7.9609 5.83832 7.9678 5.84293 7.97539 5.84608C7.98299 5.84923 7.99113 5.85086 7.99935 5.85086C8.00757 5.85086 8.01571 5.84923 8.0233 5.84608C8.03089 5.84293 8.03779 5.83832 8.0436 5.83249L12.4396 1.43799Z"
        fill="#E7E6F8"
      />
    </g>
    <defs>
      <clipPath id="clip0_2_15788">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const passwordEye = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.7071 5.70833C5.45709 5.95843 5.31667 6.2976 5.31673 6.65124C5.31679 7.00487 5.45733 7.34399 5.70743 7.594C5.95753 7.84401 6.2967 7.98443 6.65033 7.98437C7.00397 7.98431 7.34309 7.84377 7.5931 7.59367M9.77106 9.76574C8.83588 10.3508 7.75349 10.6577 6.65039 10.6504C4.25039 10.6504 2.25039 9.31708 0.650391 6.65041C1.49839 5.23708 2.45839 4.19841 3.53039 3.53441M5.43706 2.77041C5.83642 2.68956 6.24293 2.64936 6.65039 2.65041C9.05039 2.65041 11.0504 3.98374 12.6504 6.65041C12.2064 7.39041 11.7311 8.02841 11.2251 8.56374M0.650391 0.650391L12.6504 12.6504"
      stroke="white"
      strokeOpacity="0.5"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
